import { COLORS, ASSETS } from "../styles/tokens";

/**
 * BrandBackground — fixed-attachment Leanback background image with
 * atmospheric gradient overlays. Sits behind all content at z-index 0.
 */
export function BrandBackground() {
  return (
    <>
      <div
        style={{
          position: "fixed",
          inset: 0,
          backgroundImage: `url('${ASSETS.bg}')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          opacity: 0.55,
          zIndex: 0,
          pointerEvents: "none",
        }}
      />
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: `
            radial-gradient(ellipse 90% 50% at 50% -12%, rgba(94, 234, 212, 0.10) 0%, transparent 60%),
            radial-gradient(ellipse at 16% 22%, rgba(94, 234, 212, 0.08) 0%, transparent 46%),
            radial-gradient(ellipse at 84% 18%, rgba(167, 139, 250, 0.07) 0%, transparent 44%),
            radial-gradient(ellipse at 78% 84%, rgba(59, 130, 246, 0.09) 0%, transparent 52%),
            linear-gradient(180deg, ${COLORS.bg}aa 0%, ${COLORS.bg}cc 60%, ${COLORS.bg} 100%)
          `,
          zIndex: 0,
          pointerEvents: "none",
        }}
      />
      {/* Vignette — darkens edges to push content forward (depth layer 3) */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          background:
            "radial-gradient(ellipse 75% 65% at 50% 38%, transparent 55%, rgba(3, 7, 15, 0.55) 100%)",
          zIndex: 0,
          pointerEvents: "none",
        }}
      />
    </>
  );
}

/**
 * NoiseOverlay — inline SVG fractal noise rendered at low opacity over the
 * entire page. Adds film-grain texture without external assets or network
 * requests. Honors `prefers-reduced-motion` (it's static, no animation).
 */
export function NoiseOverlay() {
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0'/></filter><rect width='200' height='200' filter='url(%23n)'/></svg>`;
  return (
    <div
      className="noise-overlay"
      style={{
        backgroundImage: `url("data:image/svg+xml;utf8,${svg}")`,
        backgroundSize: "200px 200px",
      }}
    />
  );
}
